import { ICompanyOverview } from "../../Interfaces/ICompanyOverview";
import { ICompanyOverviewPanelItem } from "../../Interfaces/ICompanyOverviewPanelItem";
import BusinessIcon from "@mui/icons-material/Business";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BadgeIcon from "@mui/icons-material/Badge";
import LanguageIcon from "@mui/icons-material/Language";
import SocialDistanceIcon from "@mui/icons-material/SocialDistance";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import AttributionIcon from "@mui/icons-material/Attribution";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ModeIcon from "@mui/icons-material/Mode";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AttachmentIcon from "@mui/icons-material/Attachment";
import ContactsIcon from "@mui/icons-material/Contacts";
import { EDITOR_TYPES } from "src/Shared/Enums";
import { FileUpload } from "@mui/icons-material";
import FileUploader from "src/Shared/Components/CoreUI/FileUploader/FileUploader";
import { numericFormatter } from "react-number-format";
import { AttachmentTypeEnum } from "src/Shared/Enums/AttachmentType.enum";
import { VendorType } from "../../Enums/VendorType";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import IntegrationInstructionsTwoToneIcon from "@mui/icons-material/IntegrationInstructionsTwoTone";

const listToString = (list: string[]) => {
  return list?.join(", ") || "";
};
export const panelList = (
  companyOverview: ICompanyOverview
): ICompanyOverviewPanelItem[] => {
  return [
    {
      label: "Company Name:",
      value: companyOverview.companyName,
      icon: <BusinessIcon />,
    },
    {
      label: "National/Regional:",
      value: companyOverview.companyType,
      icon: <MyLocationIcon />,
    },
    {
      label: "Status",
      value: companyOverview.status,
      icon: <AutorenewIcon />,
    },
    {
      label: "Sales Pipeline Value:",
      value: numericFormatter(`${companyOverview.salesTotalValue}`, {
        thousandSeparator: true,
        decimalScale: 2,
        fixedDecimalScale: true,
        prefix: "$",
      }),
      icon: <AttachMoneyIcon />,
    },
    {
      label: "TDDA Supporting Region:",
      value: companyOverview.franchiseName,
      icon: <MyLocationIcon />,
    },
    {
      label: "TDDA/Healthtick:",
      // value: companyOverview.vendorTypes,
      value: listToString(companyOverview.vendorTypes),
      icon: <BadgeIcon />,
    },
    {
      label: "Services:",
      value: listToString(companyOverview.services),
      icon: <LanguageIcon />,
    },
    {
      label: "Primary TDDA Relationship Manager:",
      value: companyOverview.primaryCompanyRelationshipManager,
      icon: <SocialDistanceIcon />,
    },
    {
      label: "CompanySize:",
      value: companyOverview.totalStaffNumber,
      icon: <SupervisorAccountIcon />,
    },
    {
      label: "Lead:",
      value: companyOverview.leadType,
      icon: <AttributionIcon />,
    },
    {
      label: "Deal Stage:",
      value: companyOverview.dealStage,
      icon: <LocalOfferIcon />,
    },
    {
      label: "Signed SLA:",
      value: companyOverview.isSLASigned ? "Yes" : "No",
      icon: <ModeIcon />,
    },
    {
      label: "SLA Expiry Date:",
      value: companyOverview.slaExpiryDate || "-",
      icon: <DateRangeIcon />,
    },
    {
      label: "Tdda Attachments:",
      value: (
        <FileUploader
          value={companyOverview.attachments.filter(
            (x) => x.attachmentTypeID == AttachmentTypeEnum.TDDA
          )}
          multiple={true}
          readonly={true}
          showLabel={false}
        ></FileUploader>
      ),
      icon: <AttachmentIcon />,
      isHidden: !companyOverview.vendorTypeIDs.some(
        (x) => x == VendorType.TDDA
      ),
    },
    {
      label: "HealthTick Attachments:",
      value: (
        <FileUploader
          value={companyOverview.attachments.filter(
            (x) => x.attachmentTypeID == AttachmentTypeEnum.HealthTick
          )}
          multiple={true}
          readonly={true}
          showLabel={false}
        ></FileUploader>
      ),
      icon: <AttachmentIcon />,
      isHidden: !companyOverview.vendorTypeIDs.some(
        (x) => x == VendorType.Healthtick
      ),
    },
    {
      label: "Client Primary Contact:",
      value: companyOverview.primaryContactName,
      icon: <ContactsIcon />,
    },
    {
      label: "Imperans Integration:",
      value: companyOverview.companyIntegrationStatus,
      icon: <IntegrationInstructionsTwoToneIcon />,
    },

    {
      label: "Integrated Company:",
      value: companyOverview.companyIntegrationDetail?.label,
      icon: <IntegrationInstructionsTwoToneIcon />,
      isHidden: companyOverview.companyIntegrationDetail == null,
    },
  ];
};
